export default "__VITE_ASSET__DCEtFygO__"